import { render, staticRenderFns } from "./FalecidoSV.vue?vue&type=template&id=ff44ca7c&"
import script from "./FalecidoSV.vue?vue&type=script&lang=js&"
export * from "./FalecidoSV.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports